import { ChangeEvent, SyntheticEvent, useContext, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import commonStyles from "../common.module.css";
import { AuthResetPasswordPayload } from "../../api/types/auth";
import { FormErrors } from "../../api/types/base";
import { classNames } from "primereact/utils";
import { NavLink, useNavigate } from "react-router-dom";
import { useResetPassword } from "../../api/queries/auth/useResetPassword";
import { appToastContext } from "../../context/toast";

export default function AuthResetPassword() {
  const navigate = useNavigate();
  const resetPassword = useResetPassword();
  const { ref: appToastRef } = useContext(appToastContext);

  const [email, setEmail] = useState<string>("");
  const handleEmailChange = (event: ChangeEvent<HTMLInputElement>) =>
    setEmail(event.target.value);

  const [errors, setErrors] = useState<FormErrors<AuthResetPasswordPayload>>();
  const validate = (): boolean => {
    let newErrors: FormErrors<AuthResetPasswordPayload> = {};

    if (!email) {
      newErrors.email = "";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event: SyntheticEvent) => {
    event.preventDefault();

    if (!validate()) {
      return;
    }

    await resetPassword.mutateAsync({ email });

    appToastRef?.current?.show({
      severity: "info",
      summary: "Further instructions have been sent to your email.",
    });

    navigate("/login");
  };

  const footer = () => (
    <div className="text-center">
      <small className="block">
        Do you have already an account? <NavLink to={"/login"}>Sign in</NavLink>
        .
      </small>
    </div>
  );

  return (
    <form className={"col-12 p-fluid"} onSubmit={handleSubmit}>
      <Card
        title={"Reset password"}
        className={"col-12 md:col-4 md:col-offset-4"}
        footer={footer}
      >
        <div className={"field"}>
          <label className={commonStyles.labelRequired}>E-mail:</label>
          <InputText
            value={email}
            onChange={handleEmailChange}
            name={"email"}
            autoComplete={"on"}
            className={classNames({
              "p-invalid": errors?.hasOwnProperty("username"),
            })}
          />
        </div>

        <Button label={"Reset password"} />
      </Card>
    </form>
  );
}
